import styled from 'styled-components';

export const ModalContainer = styled.div`
  display: flex;
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const TextContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
`;
